<template>
  <el-button @click="open">{{ t('qrStyleView') }}</el-button>
  <el-dialog v-model="visible" :title="t('qrStylePreviewTitle')" width="440px" align-center append-to-body>
    <div class="flex flex-wrap justify-center gap-2 mb-3">
      <el-button
          v-for="s in QR_IMAGE_STYLES" :key="s" size="small" round
          :type="s === previewStyle ? 'primary' : 'default'"
          @click="previewStyle = s"
      >{{ t(styleLabel(s)) }}</el-button>
    </div>
    <div v-loading="loading" class="flex justify-center items-center bg-gray-100 rounded-lg p-2" style="min-height: 420px">
      <img v-if="image" :src="image" alt="" class="rounded shadow" style="max-height: 62vh; max-width: 100%; object-fit: contain">
    </div>
    <template #footer>
      <el-button @click="visible = false">{{ t('qrStyleClose') }}</el-button>
      <el-button type="primary" :disabled="previewStyle === selected" @click="useStyle">{{ t('qrStyleUse') }}</el-button>
    </template>
  </el-dialog>
</template>
<script setup lang="ts">
import {ref, watch} from 'vue'
import {useI18n} from 'vue-i18n'
import {useSettingsStore} from '@/stores/settingsStore'
import {QR_IMAGE_STYLES, renderQRCard} from '@/utils/qrExport'
import samiLogo from '@/assets/images/logo.svg'

const props = defineProps<{ selected?: string }>()
const emit = defineEmits<{ (e: 'select', value: string): void }>()

const {t, locale} = useI18n({useScope: 'global'})
const settingsStore = useSettingsStore()

const visible = ref(false)
const loading = ref(false)
const image = ref('')
const previewStyle = ref<string>('professional')
let renderToken = 0

const styleLabel = (s: string) => 'qrStyle' + s.charAt(0).toUpperCase() + s.slice(1)

function today(): string {
  const d = new Date()
  return [d.getDate(), d.getMonth() + 1].map(n => String(n).padStart(2, '0')).join('-') + '-' + d.getFullYear()
}

async function render() {
  const token = ++renderToken
  loading.value = true
  try {
    const logo = settingsStore.getValue('examination_main_logo')
    const dataUrl = await renderQRCard({
      qrUrl: `https://exams.thecky.com/${settingsStore.getValue('viewer_client_key') || 'test'}/preview`,
      logoSrc: logo ? settingsStore.storagePath + '/' + logo : samiLogo,
      customerName: locale.value === 'ar' ? 'سارة أحمد' : 'Sara Ahmed',
      externalID: '124011',
      examDate: today(),
      brandColor: settingsStore.getValue('receipt_branding_color'),
      style: previewStyle.value
    })
    if (token === renderToken) image.value = dataUrl
  } finally {
    if (token === renderToken) loading.value = false
  }
}

function open() {
  previewStyle.value = (QR_IMAGE_STYLES as readonly string[]).includes(props.selected || '') ? props.selected as string : 'professional'
  visible.value = true
  render()
}

function useStyle() {
  emit('select', previewStyle.value)
  visible.value = false
}

watch(previewStyle, () => { if (visible.value) render() })
</script>
